// import React from 'react'

// const ViewUserGroups = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default ViewUserGroups

import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { usergroupdata } from "../../assets/Griddata"; // Import dataset
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { externalgetApi } from "../../services/external/externalApis";
import { EMPLOYEE_API_01, USERGROUP_API_01 } from "../../api/ApiModel";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import SearchAppBar from "../../components/common/search";
function ViewUserGroups() {
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, BUSINESSTYPECODE } = SYS_USER.USER_PARAM || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const goToPage = () => {
    navigate("/AddUserGroups");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(USERGROUP_API_01, "get", {
          COMPCODE,

          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [COMPCODE, LOCCODE, BUSINESSTYPECODE]);

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) =>
        item.GROUPNAME.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.GROUPCODE === id);
      if (selectedItem) {
        navigate(`/AddUserGroups`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/AddUserGroups`, { state: { selectedItem: "" } });
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        GROUPCODE: item.GROUPCODE,
        GROUPNAME: item.GROUPNAME,
        STS: item.STS,
      }))
    : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Employee</Link>
                <Link underline="none">View User Group</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={goToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={usergroupdata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={usergroupdata.name}
          gridid="GROUPCODE"
        />
      )}
    </div>
  );
}

export default ViewUserGroups;
